#import "../fragments/trial-info-fragment.graphql"

query GetTrialInfo {
    sessionInstance {
        ...TrialInfo
    }
}
